import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import LrCancelPenalityTable from './LrCancelPenalityTable'
import { connect } from 'react-redux'
import { getLRPenaltyReportFilterData, getLRPenaltyReportTableData } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { urls, xlCol, xlColq } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
const LrCancelPenalityReport = (props) => {
    const { data: { common, reports }, getLRPenaltyReportFilterData, getLRPenaltyReportTableData, updateAlertError } = props
    const { loginData,companySettings } = common
    const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
    const { lrPenaltyReportFilterData, lrPenaltyReportTableData } = reports
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [showReport, setShowReport] = useState(false)
    const [sourceCityData, setSourceCityData] = useState([])
    const [sourceBranchData, setSourceBranchData] = useState([])
    const [sourceCity, setSourceCity] = useState(sourceCityData[0])
    const [sourceBranch, setSourceBranch] = useState(sourceBranchData[0])
    const [tableData, setTableData] = useState([])
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const headerColumn = [
        { header: 'LR No.\nManual LR No.', exportHead: 'LR No.\nManual LR No.', field: 'LrManNo', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR Booking\nDate & Time', exportHead: 'LR Booking\nDate & Time', field: 'BookDateTime', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Booked By\nUser', exportHead: 'Booked By\nUser', field: 'BookedByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Source\nCity', exportHead: 'Source\nCity', field: 'SourceCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Destination\nCity', exportHead: 'Destination\nCity', field: 'DestinationCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR\nUnits', exportHead: 'LR\nUnits', field: 'Units', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Total LR\nAmount', exportHead: 'Total LR\nAmount', field: 'NetAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Penality\nAmount', exportHead: 'Penality\nAmount', field: 'LRPenaltyAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'LR Cancel\nDate & Time', exportHead: 'LR Cancel\nDate & Time', field: 'LRCancelDate', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Cancel By\nUser', exportHead: 'Cancel By\nUser', field: 'CancelByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
    ]
    const headerColumnFormattedLRNO = [
        { header: 'Formatted LRNO\nManual LR No.', exportHead: 'Formatted LRNO\nManual LR No.', field: 'LrManNo', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR Booking\nDate & Time', exportHead: 'LR Booking\nDate & Time', field: 'BookDateTime', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Booked By\nUser', exportHead: 'Booked By\nUser', field: 'BookedByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Source\nCity', exportHead: 'Source\nCity', field: 'SourceCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Destination\nCity', exportHead: 'Destination\nCity', field: 'DestinationCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR\nUnits', exportHead: 'LR\nUnits', field: 'Units', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Total LR\nAmount', exportHead: 'Total LR\nAmount', field: 'NetAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Penality\nAmount', exportHead: 'Penality\nAmount', field: 'LRPenaltyAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'LR Cancel\nDate & Time', exportHead: 'LR Cancel\nDate & Time', field: 'LRCancelDate', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Cancel By\nUser', exportHead: 'Cancel By\nUser', field: 'CancelByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
    ]
    const headerColumnForBoth = [
        { header: 'LR No.\nManual LR No.', exportHead: 'LR No.\nManual LR No.', field: 'LrManNo', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR Booking\nDate & Time', exportHead: 'LR Booking\nDate & Time', field: 'BookDateTime', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Booked By\nUser', exportHead: 'Booked By\nUser', field: 'BookedByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Source\nCity', exportHead: 'Source\nCity', field: 'SourceCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'Destination\nCity', exportHead: 'Destination\nCity', field: 'DestinationCityName', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
        { header: 'LR\nUnits', exportHead: 'LR\nUnits', field: 'Units', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Total LR\nAmount', exportHead: 'Total LR\nAmount', field: 'NetAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'Penality\nAmount', exportHead: 'Penality\nAmount', field: 'LRPenaltyAmount', xlCol: xlColq, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "right" },
        { header: 'LR Cancel\nDate & Time', exportHead: 'LR Cancel\nDate & Time', field: 'LRCancelDate', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "100px", align: "left" },
        { header: 'Cancel By\nUser', exportHead: 'Cancel By\nUser', field: 'CancelByUser', xlCol: xlCol, pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 53, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, }, minWidth: "80px", align: "left" },
    ]

    const headerFilterColumn = [
        { header: 'From Cancel Date', exportHead: 'From Cancel Date', field: 'FromDate', xlCol: xlCol, minWidth: "80px", align: "left" },
        { header: 'To Cancel Date', exportHead: 'To Cancel Date', field: 'ToDate', xlCol: xlCol, minWidth: "100px", align: "left" },
        { header: 'City Name', exportHead: 'City Name', field: 'City', xlCol: xlCol, minWidth: "80px", align: "left" },
        { header: 'Branch Name', exportHead: 'Branch Name', field: 'Branch', xlCol: xlCol, minWidth: "100px", align: "left" },
    ]

    const HeaderData = {
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      City: sourceCity?.CityName,
      Branch: sourceBranch?.BranchName,
      dataType: 'entry'
    }
    const headerColumnData=UseFormattedLRinReports===0||UseFormattedLRinReports===1?headerColumn:UseFormattedLRinReports===2?headerColumnFormattedLRNO:headerColumnForBoth
    // const groupData = (value, key) => {
    //     const data = value?.map((val, i) => ({
    //         ...val, LrManNo: `${val.LRNo}\n${val.ManualLRNo}`, BookDateTime: `${moment(val.BookingDateTime).format("DD-MMM-YY")}\n${moment(val.BookingDateTime).format("hh:mm A")}`, CancelDateTime: `${moment(val.LRCancelDate).format("DD-MMM-YY")}\n${moment(val.LRCancelDate).format("HH:mm A")}`, isDataRow: true
    //     }))
    //     let SubHeading = {
    //         LRNo: `City: ${key?.split('-')?.[0]}`,
    //         CancelByUser: `Branch: ${key?.split('-')?.[1]}`,
    //         isSubHeading: true
    //     }
    //     let TotalUnit = 0;
    //     let TotalNetAmount = 0;
    //     let TotalLRPenaltyAmount = 0;
    //     data?.map((val) => {
    //         TotalUnit += Number(val.Units)
    //         TotalNetAmount += Number(val.NetAmount)
    //         TotalLRPenaltyAmount += Number(val.LRPenaltyAmount)
    //     })
    //     data?.push({
    //         LrManNo: `TOTAL: City: ${key?.split('-')?.[0]}, Branch: ${key?.split('-')?.[1]}`,
    //         Units: TotalUnit.toFixed(2),
    //         NetAmount: TotalNetAmount.toFixed(2),
    //         LRPenaltyAmount: TotalLRPenaltyAmount.toFixed(2),
    //         isTotalRow: true
    //     })
    //     // data.unshift(headerColumnObj)
    //     data.unshift(SubHeading)
    //     return data || []
    // }
    // const groupedDetailedData = (data) => {
    //     const groupedData = data.reduce((result, item) => {
    //         const key = `${item.SourceCityName}-${item.SourceBranch}`
    //         if (!result[key]) {
    //             result[key] = []
    //         } result[key].push(item)
    //         return result
    //     }, {})
    //     let newData = []
    //     Object.keys(groupedData).map((val, key) => {
    //         const updateData = groupData(groupedData[val], val);
    //         newData = [...newData, ...updateData]
    //     })
    //     return newData
    // }
    const mainHeader = headerColumnData?.map((val) => ({
         ...val,
        //  align: val.headerSx.textAlign,
         export: val.exportHead,
         weight: 80,
    }))
    useEffect(() => {
        // if (lrPenaltyReportFilterData.status==='Success') {
        if (lrPenaltyReportFilterData?.Table?.length > 0) {
            const SourceCity = [...new Set(lrPenaltyReportFilterData?.Table?.map((val) => ({ CityName: val.CityName, CityID: val.CityID }))),]
            const selectedCity = SourceCity?.filter((val) => val.CityID === loginData?.intBranchCityID)
            const SourceBranch = [...new Set(lrPenaltyReportFilterData?.Table?.map((val) => ({ BranchName: val.BranchName, BranchID: val.BranchID, CityID: val.CityID }))),]
            const selectedBranch = SourceBranch?.filter((val) => val.BranchID === loginData?.intBranchID)
            if (selectedCity?.length > 0) {
                setSourceCity(selectedCity?.[0])
            } else {
                setSourceCity({ CityName: "All Cities", CityID: 0 })
            }
            if (selectedBranch?.length > 0) {
                setSourceBranch(selectedBranch?.[0])
            } else {
                setSourceBranch({ BranchName: "All Branch", BranchID: 0 })
            }
            setSourceCityData([{ CityName: "All Cities", CityID: 0 }, ...SourceCity])
            setSourceBranchData([{ BranchName: "All Branch", BranchID: 0 }, ...SourceBranch])
        } else {
            setSourceCityData([])
            // setSourceBranchData([])
            // }
        }
    }, [lrPenaltyReportFilterData])
    // useEffect(() => {
    //     if (lrPenaltyReportTableData?.Table?.length > 0) {
    //         const data = groupedDetailedData(lrPenaltyReportTableData?.Table)
    //         setTableData(data)
    //     } else {
    //         setTableData([])
    //     }
    // }, [lrPenaltyReportTableData])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    // const generateReport = () => {
    //     setShowReport(true)
    //     if (sourceCity == '' || sourceCity == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Source City', nextId: '' })
    //     } else if (sourceBranch == "" || sourceBranch == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' })
    //     } else {
    //         const obj = {
    //             CompanyID: loginData?.intCompanyID,
    //             CancelFromDate: moment(fromDate).format('YYYY-MM-DD'),
    //             CancelToDate: moment(toDate).format('YYYY-MM-DD'),
    //             CityID: sourceCity?.CityID,
    //             BranchID: sourceBranch?.BranchID
    //         }
    //         getLRPenaltyReportTableData(obj)
    //     }
    // }
    const groupData = (data) => {
      const groupedData = data.reduce((result, item) => {
        const key = `${item.SourceCityName}-${item.SourceBranch}`
        if (!result[key]) {
          result[key] = []
        }
        result[key].push(item)
        return result
      }, {})

      let finalData = []

      // ✅ Step 2: Process each group
      Object.keys(groupedData).forEach((key) => {
        const group = groupedData[key]

        // 🔹 Format rows
        const formattedData = group.map((val) => ({
          ...val,
          LrManNo: `${val.LRNo}\n${val.ManualLRNo}`,
          BookDateTime: `${moment(val.BookingDateTime).format('DD-MMM-YY')}\n${moment(val.BookingDateTime).format('hh:mm A')}`,
          CancelDateTime: `${moment(val.LRCancelDate).format('DD-MMM-YY')}\n${moment(val.LRCancelDate).format('HH:mm A')}`,
          isDataRow: true,
        }))

        // 🔹 SubHeading
        const SubHeading = {
          LrManNo: `City: ${key.split('-')[0]}`,
          Units: `Branch: ${key.split('-')[1]}`,
          isSubHeading: true,
          dataType:'subHeader',
          colSpan:{LrManNo:5,Units:5},
          align:{Units:'right'}
        }

        // 🔹 Totals
        let TotalUnit = 0
        let TotalNetAmount = 0
        let TotalLRPenaltyAmount = 0

        formattedData.forEach((val) => {
          TotalUnit += Number(val.Units)
          TotalNetAmount += Number(val.NetAmount)
          TotalLRPenaltyAmount += Number(val.LRPenaltyAmount)
        })

        const totalRow = {
          LrManNo: `TOTAL: City: ${key.split('-')[0]}, Branch: ${key.split('-')[1]}`,
          Units: TotalUnit.toFixed(2),
          NetAmount: TotalNetAmount.toFixed(2),
          LRPenaltyAmount: TotalLRPenaltyAmount.toFixed(2),
          isTotalRow: true,
          dataType: 'total',
          colSpan:{LrManNo:5}
        }
        finalData.push(SubHeading, ...formattedData, totalRow)
      })
      return finalData
    }
    const generateReport = () => {
      if (sourceCity == '' || sourceCity == ' ') {
        setAlert({ show: true, msg: 'Select Source City', nextId: '' })
        return
      }
      if (sourceBranch == '' || sourceBranch == ' ') {
        setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
        return
      }
      setLoader(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        CancelFromDate: moment(fromDate).format('YYYY-MM-DD'),
        CancelToDate: moment(toDate).format('YYYY-MM-DD'),
        CityID: sourceCity?.CityID,
        BranchID: sourceBranch?.BranchID,
      }
      GetRequest(urls.getLRPenaltyReportTableData, obj)
        .then((res) => {
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Request Failed')
          }
          if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
            throw new Error('No Data Found')
          }
          const updatedData = res?.Data?.Table?.map((item) => ({ ...item, dataType: 'entry' }))
          const data = groupData(updatedData)
          const reportPayload = {
            reportName,
            criteriaHeaders: headerFilterColumn,
            criteriaData: [HeaderData],
            tableData: data,
            mainHeader: mainHeader,
            isShowManageColumn: false,
            manageColumnID: '',
            hideHeader: false,
            colSpanMarker: "DestinationCityName"
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, '_blank')
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: '' })
        })
        .finally(() => setLoader(false))
    }
    const handleGoClick = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            const obj = {
                CompanyID: loginData?.intCompanyID,
                CancelFromDate: moment(fromDate).format('YYYY-MM-DD'),
                CancelToDate: moment(toDate).format('YYYY-MM-DD'),
            }
            getLRPenaltyReportFilterData(obj)

        }
    }
    const selectedSourceCity = (obj) => {
        setShowReport(false)
        setSourceCity(obj)
        setSourceBranch(sourceBranchData?.filter((val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0)?.[0])
    }
    const reportName = 'LR Cancel Penalty'
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <ReportHeading reportName={reportName} />
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            // id={id.selectCompnay}
                            label={"Select Company"}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => setSelCompany(val)}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Cancel Date`}
                            name={'from_date'}
                            value={fromDate}
                            id={'fromDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Cancel Date'}
                            name={'to_date'}
                            value={toDate}
                            id={'toDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goButtonDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            id={'goButtonDate'}
                            onClick={handleGoClick}
                            onKeyDown={(e) => { navigation3(e, 'selectedCity', 'toDate', () => handleGoClick()) }}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select City`}
                            id={'selectedCity'}
                            data={sourceCityData || []}
                            // disabled={disableBtn}
                            defaultvalue={sourceCity?.CityName || sourceCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedSourceCity(obj) }}
                            // onSelect={(val) => { setShowReport(false); setSourceCity(val) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Branch'}
                            // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                            // data={sourceBranchData || []}
                            data={
                                sourceBranchData?.filter(
                                    (val) => val.CityID === sourceCity?.CityID || sourceCity?.CityID === 0 || val.BranchID === 0
                                ) || []
                            }
                            defaultvalue={sourceBranch?.BranchName || sourceBranch}
                            dataKey={`BranchName`}
                            idKey={`BranchID`}
                            // onSelect={(val) => { selectedSourceBranch(val) }}
                            onSelect={(val) => { setShowReport(false); setSourceBranch(val) }}
                            nextId={'generateButton'}
                            prevId={'selectedCity'}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={'generateButton'}
                            onClick1={generateReport}
                        // onClick2={handleClick2}
                        />
                    </Item>
                </Box>
            </Item>
            {
                showReport ? <LrCancelPenalityTable headerColumn={headerColumnData} tableData={tableData} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} fromDate={fromDate} toDate={toDate} UseFormattedLRinReports={UseFormattedLRinReports}/> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getLRPenaltyReportFilterData, getLRPenaltyReportTableData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(LrCancelPenalityReport)